import { render, staticRenderFns } from "./cloudPayCertCheck.vue?vue&type=template&id=2b86c046&"
import script from "./cloudPayCertCheck.vue?vue&type=script&lang=js&"
export * from "./cloudPayCertCheck.vue?vue&type=script&lang=js&"
import style0 from "./cloudPayCertCheck.vue?vue&type=style&index=0&id=2b86c046&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports